import { Entity } from '@/interfaces/entity';
import { Role } from './role';
import { BusinessUnit } from './business_unit';
import { Location } from './location';
import { Department } from './department';
import { Designation } from './designation';

export class User implements Entity{
    id: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    full_name: string;
    employee_number: string;
    email: string;
    business_unit_id: string;
    designation_id: string;
    department_id: string;
    location_id: string;
    role_id: string;
    business_unit: BusinessUnit;
    designation: Designation;
    department: Department;
    location: Location;
    role: Role;

    constructor(
        id = "",
        first_name = "",
        middle_name = "",
        last_name = "",
        full_name = "",
        employee_number = "",
        email = "",
        business_unit_id = "",
        designation_id = "",
        department_id = "",
        location_id = "",
        role_id = "", 
        business_unit = new BusinessUnit(),
        designation = new Designation(),
        department = new Department(),
        location = new Location(),
        role= new Role(), 
    ){
        this.id = id;
        this.first_name = first_name;
        this.middle_name = middle_name;
        this.last_name = last_name;
        this.full_name = full_name;
        this.employee_number = employee_number;
        this.email = email;
        this.business_unit = business_unit;
        this.designation = designation;
        this.department = department;
        this.location = location;
        this.role = role;
        this.business_unit_id = business_unit_id;
        this.designation_id = designation_id;
        this.department_id = department_id;
        this.location_id = location_id;
        this.role_id = role_id;
    }

    get auth_id(){
        return this.id;
    }

    isAdmin(){
        return this.role.name == 'Admin';
    }
}